<template>
  <div class="flex flex-row justify-center mb-2 mt-3">
    <div class="md:w-full text-center">
      <p class="text-white">
        <slot>
          <h5 v-if="authStore.getLandingPageLanguage == 'en'" class="text-sm md:text-md">
            To login to NasnaTV service please enter your Mobily
            number.
          </h5>
          <h5 v-if="authStore.getLandingPageLanguage == 'ar'" dir="rtl" class="text-sm md:text-md">
            لتسجيل الدخول إلى خدمة NasnaTV ، يرجى إدخال رقم موبايلي الخاص بك
          </h5>
        </slot>
      </p>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
};
</script>

<style></style>
